(() => {
  const end = Date.parse('2026-11-01T00:00:00+11:00');
  const maxTimeout = 2147000000;
  let timeout;
  function expireBirthdaySale() {
    if (timeout !== undefined) window.clearTimeout(timeout);
    const remaining = end - Date.now();
    if (remaining > 0) {
      timeout = window.setTimeout(expireBirthdaySale, Math.min(remaining, maxTimeout));
      return;
    }
    timeout = undefined;
    document.querySelectorAll('[data-baroona-birthday-until]').forEach((element) => {
      element.hidden = true;
    });
    document.querySelectorAll('[data-baroona-birthday-fallback]').forEach((element) => {
      element.hidden = false;
    });
  }
  expireBirthdaySale();
  window.addEventListener('pageshow', expireBirthdaySale);
  document.addEventListener('visibilitychange', expireBirthdaySale);
})();
